(() => {
  function initBvmProductZero(root = document) {
    const sections = root.querySelectorAll('[data-bvm-product-zero]');

    sections.forEach((section) => {
      initVariantSelector(section);
      initGallery(section);
      initProductDescription(section);
      initCardSliders(section);
      initVideoBlocks(section);
      initBeforeAfter(section);
      initRichAccordions(section);
      initFaqAccordions(section);
      initReviews(section);
      initRelatedSliders(section);
    });
  }

  function initVariantSelector(section) {
  const select = section.querySelector('[data-bvm-variant-select]');

  if (!select || select.dataset.bvmVariantReady === 'true') return;

  select.dataset.bvmVariantReady = 'true';

  select.addEventListener('change', () => {
    const variantId = select.value;

    if (!variantId) return;

    const url = new URL(window.location.href);

    if (url.searchParams.get('variant') === variantId) return;

    url.searchParams.set('variant', variantId);

    window.location.assign(url.toString());
  });
}
  function initGallery(section) {
    const gallery = section.querySelector('[data-bvm-gallery-v4]');
    if (!gallery || gallery.dataset.bvmReady === 'true') return;
    gallery.dataset.bvmReady = 'true';

    const desktopImage = gallery.querySelector('[data-bvm-desktop-main-image]');
    const desktopZoom = gallery.querySelector('[data-bvm-desktop-zoom]');
    const desktopPrev = gallery.querySelector('[data-bvm-desktop-prev]');
    const desktopNext = gallery.querySelector('[data-bvm-desktop-next]');

    const mobileTrack = gallery.querySelector('[data-bvm-mobile-track]');
    const mobileZooms = Array.from(gallery.querySelectorAll('[data-bvm-mobile-zoom]'));
    const mobilePrev = gallery.querySelector('[data-bvm-mobile-prev]');
    const mobileNext = gallery.querySelector('[data-bvm-mobile-next]');

    const thumbs = Array.from(gallery.querySelectorAll('[data-bvm-gallery-thumb]'));
    const thumbsTrack = gallery.querySelector('[data-bvm-thumbs-track]');
    const thumbsPrev = gallery.querySelector('[data-bvm-thumbs-prev]');
    const thumbsNext = gallery.querySelector('[data-bvm-thumbs-next]');

    const modal = section.querySelector('[data-bvm-gallery-modal]');
    const modalImage = section.querySelector('[data-bvm-gallery-modal-image]');
    const modalClose = section.querySelector('[data-bvm-gallery-modal-close]');
    const modalPrev = section.querySelector('[data-bvm-gallery-modal-prev]');
    const modalNext = section.querySelector('[data-bvm-gallery-modal-next]');
    const modalThumbs = Array.from(section.querySelectorAll('[data-bvm-modal-thumb]'));

    const desktopQuery = window.matchMedia("(min-width: 750px)");
    const preloaded = new Set();

    let currentIndex = 0;
    let modalIndex = 0;
    let mobileScrollTimer = null;

    let mobileTapStartX = 0;
    let mobileTapStartY = 0;
    let mobileTapMoved = false;

    const zoom = {
      scale: 1,
      startScale: 1,
      panX: 0,
      panY: 0,
      startPanX: 0,
      startPanY: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      pinchStartDistance: 0,
      moved: false,
      lastTapTime: 0
    };

    function isMobile() {
      return !desktopQuery.matches;
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function buildItems() {
      const items = [];

      thumbs.forEach((thumb) => {
        const index = Number(thumb.dataset.index || 0);
        const src = thumb.dataset.mainSrc || '';
        const alt = thumb.dataset.mainAlt || '';
        const srcset = thumb.dataset.mainSrcset || '';
        const zoomSrc = thumb.dataset.zoomSrc || '';

        if (src) {
          items[index] = {
            index,
            src,
            srcset,
            alt,
            modalSrc: zoomSrc || src,
            modalAlt: thumb.dataset.zoomAlt || alt
          };
        }
      });

      modalThumbs.forEach((thumb) => {
        const index = Number(thumb.dataset.index || 0);
        const modalSrc = thumb.dataset.modalSrc || thumb.dataset.zoomSrc || '';
        const modalAlt = thumb.dataset.modalAlt || thumb.dataset.zoomAlt || '';

        if (!items[index] && modalSrc) {
          items[index] = {
            index,
            src: modalSrc,
            srcset: '',
            alt: modalAlt,
            modalSrc,
            modalAlt
          };
        }

        if (items[index]) {
          items[index].modalSrc = modalSrc || items[index].modalSrc || items[index].src;
          items[index].modalAlt = modalAlt || items[index].modalAlt || items[index].alt;
        }
      });

      mobileZooms.forEach((trigger) => {
        const index = Number(trigger.dataset.index || 0);
        const image = trigger.querySelector('img');
        const src = image ? (image.currentSrc || image.src || '') : '';
        const alt = image ? (image.alt || '') : '';

        if (!items[index] && src) {
          items[index] = {
            index,
            src,
            srcset: image ? (image.srcset || '') : '',
            alt,
            modalSrc: src,
            modalAlt: alt
          };
        }
      });

      if (!items.length && desktopImage) {
        items[0] = {
          index: 0,
          src: desktopImage.currentSrc || desktopImage.src || '',
          srcset: desktopImage.srcset || '',
          alt: desktopImage.alt || '',
          modalSrc: desktopImage.currentSrc || desktopImage.src || '',
          modalAlt: desktopImage.alt || ''
        };
      }

      return items.filter(Boolean);
    }

    const items = buildItems();
    if (!items.length) return;

    function clampIndex(index) {
      return (index + items.length) % items.length;
    }

    function getItem(index) {
      return items[clampIndex(index)];
    }

    function preload(src) {
      if (!src || preloaded.has(src)) return;

      preloaded.add(src);

      const image = new Image();
      image.decoding = 'async';
      image.src = src;
    }

    function preloadNear(index) {
      if (items.length < 2) return;

      preload(getItem(index + 1).src);
      preload(getItem(index - 1).src);
    }

    function preloadAllDesktopLazy() {
      if (!desktopQuery.matches || items.length < 2) return;

      window.setTimeout(() => {
        preloadNear(currentIndex);
      }, 600);

      const run = () => {
        if (!desktopQuery.matches) return;
        items.forEach((item) => preload(item.src));
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 2500);
      }
    }

    function preloadMobileNextLazy() {
      if (desktopQuery.matches || items.length < 2) return;

      window.setTimeout(() => {
        if (desktopQuery.matches) return;
        preload(getItem(1).src);
      }, 1400);
    }

    function setActiveThumb(index) {
      const safeIndex = clampIndex(index);

      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index || 0) === safeIndex);
      });

      const activeThumb = thumbs.find((thumb) => Number(thumb.dataset.index || 0) === safeIndex);
      if (!activeThumb || !thumbsTrack || !desktopQuery.matches) return;

      const left = activeThumb.offsetLeft;
      const right = left + activeThumb.offsetWidth;
      const visibleLeft = thumbsTrack.scrollLeft;
      const visibleRight = visibleLeft + thumbsTrack.clientWidth;

      if (left < visibleLeft || right > visibleRight) {
        thumbsTrack.scrollLeft = left - ((thumbsTrack.clientWidth - activeThumb.offsetWidth) / 2);
      }
    }

    function setActiveModalThumb(index) {
      const safeIndex = clampIndex(index);

      modalThumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.index || 0) === safeIndex);
      });
    }

    function setDesktopImage(index) {
      if (!desktopImage) return;

      const safeIndex = clampIndex(index);
      const item = getItem(safeIndex);
      if (!item || !item.src) return;

      currentIndex = safeIndex;
      setActiveThumb(currentIndex);
      preloadNear(currentIndex);

      if (desktopZoom) {
        desktopZoom.dataset.index = String(currentIndex);
      }

      desktopImage.removeAttribute('srcset');
      desktopImage.removeAttribute('sizes');

      if (desktopImage.getAttribute('src') !== item.src) {
        desktopImage.src = item.src;
      }

      desktopImage.alt = item.alt || '';
    }

    function getMobileIndex() {
      if (!mobileTrack) return currentIndex;

      const width = mobileTrack.clientWidth || 1;
      return clampIndex(Math.round(mobileTrack.scrollLeft / width));
    }

    function setMobileImage(index, smooth = true) {
      if (!mobileTrack) return;

      currentIndex = clampIndex(index);

      mobileTrack.scrollTo({
        left: currentIndex * mobileTrack.clientWidth,
        behavior: smooth ? 'smooth' : 'auto'
      });

      setActiveThumb(currentIndex);
    }

    function getMobileModalSource(index, fallbackSrc, fallbackAlt) {
      const safeIndex = clampIndex(index);
      const trigger = mobileZooms.find((mobileZoom) => Number(mobileZoom.dataset.index || 0) === safeIndex);
      const image = trigger ? trigger.querySelector('img') : null;

      if (!image) {
        return {
          src: fallbackSrc,
          alt: fallbackAlt
        };
      }

      return {
        src: image.currentSrc || image.src || fallbackSrc,
        alt: image.alt || fallbackAlt
      };
    }

    function getTouchDistance(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;

      return Math.sqrt((dx * dx) + (dy * dy));
    }

    function clampZoomPan() {
      if (!modalImage) return;

      if (zoom.scale <= 1.02) {
        zoom.panX = 0;
        zoom.panY = 0;
        return;
      }

      const baseWidth = modalImage.offsetWidth || window.innerWidth;
      const baseHeight = modalImage.offsetHeight || window.innerHeight;
      const availableHeight = Math.max(1, window.innerHeight - 150);

      const maxPanX = Math.max(0, ((baseWidth * zoom.scale) - window.innerWidth) / 2 + 36);
      const maxPanY = Math.max(0, ((baseHeight * zoom.scale) - availableHeight) / 2 + 36);

      zoom.panX = clamp(zoom.panX, -maxPanX, maxPanX);
      zoom.panY = clamp(zoom.panY, -maxPanY, maxPanY);
    }

    function applyZoom(animate = false) {
      if (!modalImage) return;

      clampZoomPan();

      modalImage.style.transition = animate ? 'transform 140ms ease' : 'none';
      modalImage.style.transform = `translate3d(${zoom.panX}px, ${zoom.panY}px, 0) scale(${zoom.scale})`;

      modalImage.classList.toggle('is-bvm-zooming', !animate && zoom.scale > 1.02);
    }

    function resetZoom(animate = false) {
      zoom.scale = 1;
      zoom.startScale = 1;
      zoom.panX = 0;
      zoom.panY = 0;
      zoom.startPanX = 0;
      zoom.startPanY = 0;
      zoom.pinchStartDistance = 0;
      zoom.moved = false;

      applyZoom(animate);
    }

    function setModalImage(index) {
      if (!modalImage) return;

      const safeIndex = clampIndex(index);
      const item = getItem(safeIndex);
      if (!item) return;

      modalIndex = safeIndex;
      setActiveModalThumb(modalIndex);
      resetZoom(false);

      let src = item.src || item.modalSrc;
      let alt = item.alt || item.modalAlt || '';

      if (isMobile()) {
        const mobileSource = getMobileModalSource(modalIndex, src, alt);
        src = mobileSource.src;
        alt = mobileSource.alt;
      }

      if (src && modalImage.getAttribute('src') !== src) {
        modalImage.src = src;
      }

      modalImage.alt = alt;

      preloadNear(modalIndex);
    }

    function openModal(index) {
      if (!modal || !modalImage) return;

      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      resetZoom(false);
      setModalImage(index);
    }

    function closeModal() {
      if (!modal) return;

      resetZoom(false);

      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.style.overflow = '';

      if (isMobile()) {
        setMobileImage(modalIndex, false);
      } else {
        setDesktopImage(modalIndex);
      }
    }

    function goModal(direction) {
      setModalImage(modalIndex + direction);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        setDesktopImage(Number(thumb.dataset.index || 0));
      });
    });

    if (thumbsPrev && thumbsTrack) {
      thumbsPrev.addEventListener('click', (event) => {
        event.preventDefault();

        thumbsTrack.scrollLeft -= 220;
      });
    }

    if (thumbsNext && thumbsTrack) {
      thumbsNext.addEventListener('click', (event) => {
        event.preventDefault();

        thumbsTrack.scrollLeft += 220;
      });
    }

    if (desktopPrev) {
      desktopPrev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        setDesktopImage(currentIndex - 1);
      });
    }

    if (desktopNext) {
      desktopNext.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        setDesktopImage(currentIndex + 1);
      });
    }

    if (desktopZoom) {
      desktopZoom.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        openModal(Number(desktopZoom.dataset.index || currentIndex || 0));
      });
    }

    if (mobilePrev) {
      mobilePrev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        setMobileImage(getMobileIndex() - 1, true);
      });
    }

    if (mobileNext) {
      mobileNext.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        setMobileImage(getMobileIndex() + 1, true);
      });
    }

    if (mobileTrack) {
      mobileTrack.addEventListener('scroll', () => {
        window.clearTimeout(mobileScrollTimer);

        mobileScrollTimer = window.setTimeout(() => {
          currentIndex = getMobileIndex();
          setActiveThumb(currentIndex);
        }, 80);
      }, { passive: true });
    }

    mobileZooms.forEach((trigger) => {
      trigger.addEventListener('pointerdown', (event) => {
        if (!isMobile()) return;

        mobileTapStartX = event.clientX;
        mobileTapStartY = event.clientY;
        mobileTapMoved = false;
      }, { passive: true });

      trigger.addEventListener('pointermove', (event) => {
        if (!isMobile()) return;

        const deltaX = Math.abs(event.clientX - mobileTapStartX);
        const deltaY = Math.abs(event.clientY - mobileTapStartY);

        if (deltaX > 12 || deltaY > 12) {
          mobileTapMoved = true;
        }
      }, { passive: true });

      trigger.addEventListener('pointerup', (event) => {
        if (!isMobile() || mobileTapMoved) return;

        event.preventDefault();

        openModal(Number(trigger.dataset.index || getMobileIndex() || 0));
      }, { passive: false });

      trigger.addEventListener('click', (event) => {
        if (isMobile()) return;

        event.preventDefault();
        event.stopPropagation();

        openModal(Number(trigger.dataset.index || currentIndex || 0));
      });
    });

    if (modalClose) {
      modalClose.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        closeModal();
      });
    }

    if (modalPrev) {
      modalPrev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        goModal(-1);
      });
    }

    if (modalNext) {
      modalNext.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        goModal(1);
      });
    }

    modalThumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        setModalImage(Number(thumb.dataset.index || 0));
      });
    });

    if (modal) {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });

      modal.addEventListener('touchmove', (event) => {
        if (!isMobile() || modal.hidden) return;

        if (event.target.closest('button, .bvm-gallery-v4__modal-thumbs')) {
          return;
        }

        event.preventDefault();
      }, { passive: false });
    }

    if (modalImage) {
  let isPinchingNow = false;
  let ignoreClickUntil = 0;

  function preventTouchDefault(event) {
    if (event.cancelable) {
      event.preventDefault();
    }
  }

  function ignoreNextClick() {
    ignoreClickUntil = Date.now() + 450;
  }

  modalImage.addEventListener('touchstart', (event) => {
    if (!isMobile() || !modal || modal.hidden) return;

    if (event.touches.length === 2) {
      preventTouchDefault(event);

      isPinchingNow = true;
      ignoreNextClick();

      zoom.pinchStartDistance = getTouchDistance(event.touches);
      zoom.startScale = zoom.scale;
      zoom.startPanX = zoom.panX;
      zoom.startPanY = zoom.panY;
      zoom.moved = true;

      modalImage.classList.add('is-bvm-zooming');
      return;
    }

    if (event.touches.length === 1) {
      preventTouchDefault(event);

      const touch = event.touches[0];

      isPinchingNow = false;

      zoom.startX = touch.clientX;
      zoom.startY = touch.clientY;
      zoom.lastX = touch.clientX;
      zoom.lastY = touch.clientY;
      zoom.startPanX = zoom.panX;
      zoom.startPanY = zoom.panY;
      zoom.moved = false;

      modalImage.classList.add('is-bvm-zooming');
    }
  }, { passive: false });

  modalImage.addEventListener('touchmove', (event) => {
    if (!isMobile() || !modal || modal.hidden) return;

    if (event.touches.length === 2) {
      preventTouchDefault(event);

      if (!zoom.pinchStartDistance) {
        zoom.pinchStartDistance = getTouchDistance(event.touches);
        zoom.startScale = zoom.scale;
      }

      const distance = getTouchDistance(event.touches);
      const nextScale = zoom.startScale * (distance / zoom.pinchStartDistance);

      zoom.scale = clamp(nextScale, 1, 3);
      zoom.moved = true;

      if (zoom.scale <= 1.02) {
        zoom.panX = 0;
        zoom.panY = 0;
      }

      applyZoom(false);
      return;
    }

    if (event.touches.length === 1) {
      preventTouchDefault(event);

      const touch = event.touches[0];

      zoom.lastX = touch.clientX;
      zoom.lastY = touch.clientY;

      const deltaX = touch.clientX - zoom.startX;
      const deltaY = touch.clientY - zoom.startY;

      if (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6) {
        zoom.moved = true;
      }

      if (zoom.scale > 1.02) {
        zoom.panX = zoom.startPanX + deltaX;
        zoom.panY = zoom.startPanY + deltaY;
        applyZoom(false);
      }
    }
  }, { passive: false });

  modalImage.addEventListener('touchend', (event) => {
    if (!isMobile() || !modal || modal.hidden) return;

    if (event.touches.length === 1 && isPinchingNow) {
      const touch = event.touches[0];

      zoom.startX = touch.clientX;
      zoom.startY = touch.clientY;
      zoom.lastX = touch.clientX;
      zoom.lastY = touch.clientY;
      zoom.startPanX = zoom.panX;
      zoom.startPanY = zoom.panY;

      return;
    }

    if (event.touches.length > 0) return;

    modalImage.classList.remove('is-bvm-zooming');

    if (isPinchingNow) {
      isPinchingNow = false;
      ignoreNextClick();
      zoom.pinchStartDistance = 0;

      if (zoom.scale < 1.05) {
        resetZoom(true);
      } else {
        zoom.scale = clamp(zoom.scale, 1, 3);
        applyZoom(true);
      }

      return;
    }

    if (zoom.scale < 1.05) {
      resetZoom(true);
      return;
    }

    zoom.scale = clamp(zoom.scale, 1, 3);
    applyZoom(true);
  }, { passive: true });

  modalImage.addEventListener('touchcancel', () => {
    if (!isMobile()) return;

    isPinchingNow = false;
    zoom.pinchStartDistance = 0;
    modalImage.classList.remove('is-bvm-zooming');

    if (zoom.scale < 1.05) {
      resetZoom(true);
    } else {
      applyZoom(true);
    }
  }, { passive: true });

  modalImage.addEventListener('click', (event) => {
    if (!isMobile() || !modal || modal.hidden) return;

    event.preventDefault();
    event.stopPropagation();

    if (Date.now() < ignoreClickUntil) {
      return;
    }
  });
}

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
      } else if (event.key === 'ArrowLeft') {
        goModal(-1);
      } else if (event.key === 'ArrowRight') {
        goModal(1);
      }
    });

    setActiveThumb(currentIndex);
    preloadAllDesktopLazy();
    preloadMobileNextLazy();
  }

  function initProductDescription(section) {
    section.querySelectorAll('[data-bvm-product-description]').forEach((block) => {
      if (block.dataset.bvmReady === 'true') return;
      block.dataset.bvmReady = 'true';

      const accordions = Array.from(block.querySelectorAll('[data-bvm-description-accordion]'));
      if (!accordions.length) return;

      let isSyncing = false;

      accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', () => {
          if (isSyncing || !accordion.open) return;

          isSyncing = true;

          accordions.forEach((otherAccordion) => {
            if (otherAccordion !== accordion) {
              otherAccordion.open = false;
            }
          });

          isSyncing = false;
        });

        accordion.addEventListener('click', (event) => {
          const clickedLink = event.target.closest('a');
          const clickedInteractive = event.target.closest("button, input, select, textarea, label");
          const clickedSummary = event.target.closest('summary');

          if (clickedLink || clickedInteractive) return;
          if (clickedSummary) return;

          if (accordion.open) {
            accordion.open = false;
          }
        });
      });
    });
  }

  function scrollByCard(track, direction) {
    const firstCard = track.querySelector(':scope > *');
    if (!firstCard) return;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    const amount = firstCard.getBoundingClientRect().width + gap;

    track.scrollBy({
      left: amount * direction,
      behavior: 'smooth'
    });
  }

  function initCardSliders(section) {
    section.querySelectorAll('.bvm-card-section-zero').forEach((block) => {
      if (block.dataset.bvmSliderReady === 'true') return;
      block.dataset.bvmSliderReady = 'true';

      const track = block.querySelector('[data-bvm-card-track]');
      const prev = block.querySelector('[data-bvm-card-prev]');
      const next = block.querySelector('[data-bvm-card-next]');

      if (!track || !prev || !next) return;

      prev.addEventListener('click', () => scrollByCard(track, -1));
      next.addEventListener('click', () => scrollByCard(track, 1));
    });
  }

  function initVideoBlocks(section) {
    section.querySelectorAll('[data-bvm-video-player]').forEach((player) => {
      if (player.dataset.bvmVideoReady === 'true') return;
      player.dataset.bvmVideoReady = 'true';

      const trigger = player.querySelector('[data-bvm-video-trigger]');
      if (!trigger) return;

      function getYouTubeId(url) {
        try {
          const parsed = new URL(url);

          if (parsed.hostname.includes('youtu.be')) {
            return parsed.pathname.replace('/', '');
          }

          if (parsed.searchParams.get('v')) {
            return parsed.searchParams.get('v');
          }

          if (parsed.pathname.includes('/embed/')) {
            return parsed.pathname.split('/embed/')[1].split('/')[0];
          }

          if (parsed.pathname.includes('/shorts/')) {
            return parsed.pathname.split('/shorts/')[1].split('/')[0];
          }
        } catch (error) {}

        return '';
      }

      function getVimeoId(url) {
        try {
          const parsed = new URL(url);

          if (!parsed.hostname.includes('vimeo.com')) return '';

          return parsed.pathname.split('/').filter(Boolean).pop() || '';
        } catch (error) {}

        return '';
      }

      function isDirectVideo(url) {
        return /\.(mp4|webm|mov)(\?.*)?$/i.test(url);
      }

      trigger.addEventListener('click', () => {
        const videoUrl = trigger.dataset.videoUrl;
        if (!videoUrl || player.dataset.loaded === 'true') return;

        player.dataset.loaded = 'true';

        const youtubeId = getYouTubeId(videoUrl);
        const vimeoId = getVimeoId(videoUrl);

        if (youtubeId) {
          const iframe = document.createElement('iframe');
          iframe.className = 'bvm-product-video-zero__iframe';
          iframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`;
          iframe.title = window.BV_T("bonvent_studio.product_page_ui.product_video_d1bda1aaf7","Product video");
          iframe.loading = 'lazy';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          player.replaceChildren(iframe);
          return;
        }

        if (vimeoId) {
          const iframe = document.createElement('iframe');
          iframe.className = 'bvm-product-video-zero__iframe';
          iframe.src = `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
          iframe.title = window.BV_T("bonvent_studio.product_page_ui.product_video_d1bda1aaf7","Product video");
          iframe.loading = 'lazy';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          player.replaceChildren(iframe);
          return;
        }

        if (isDirectVideo(videoUrl)) {
          const video = document.createElement('video');
          video.className = 'bvm-product-video-zero__native';
          video.src = videoUrl;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          player.replaceChildren(video);
          return;
        }

        const iframe = document.createElement('iframe');
        iframe.className = 'bvm-product-video-zero__iframe';
        iframe.src = videoUrl;
        iframe.title = window.BV_T("bonvent_studio.product_page_ui.product_video_d1bda1aaf7","Product video");
        iframe.loading = 'lazy';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        player.replaceChildren(iframe);
      });
    });
  }

  function initBeforeAfter(section) {
    section.querySelectorAll('[data-bvm-before-after]').forEach((comparison) => {
      if (comparison.dataset.bvmReady === 'true') return;
      comparison.dataset.bvmReady = 'true';

      const range = comparison.querySelector('[data-bvm-before-after-range]');
      let isDragging = false;

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function setPosition(percent) {
        const safePercent = clamp(percent, 0, 100);
        comparison.style.setProperty('--bvm-before-after-position', `${safePercent}%`);

        if (range) {
          range.value = String(safePercent);
        }
      }

      function setPositionFromClientX(clientX) {
        const rect = comparison.getBoundingClientRect();
        if (!rect.width) return;

        const percent = ((clientX - rect.left) / rect.width) * 100;
        setPosition(percent);
      }

      function onPointerDown(event) {
        if (event.button !== undefined && event.button !== 0) return;

        isDragging = true;

        if (comparison.setPointerCapture && event.pointerId !== undefined) {
          comparison.setPointerCapture(event.pointerId);
        }

        setPositionFromClientX(event.clientX);
        event.preventDefault();
      }

      function onPointerMove(event) {
        if (!isDragging) return;

        setPositionFromClientX(event.clientX);
        event.preventDefault();
      }

      function onPointerEnd(event) {
        if (!isDragging) return;

        isDragging = false;

        if (comparison.releasePointerCapture && event.pointerId !== undefined) {
          try {
            comparison.releasePointerCapture(event.pointerId);
          } catch (error) {}
        }
      }

      comparison.addEventListener('pointerdown', onPointerDown, { passive: false });
      comparison.addEventListener('pointermove', onPointerMove, { passive: false });
      comparison.addEventListener('pointerup', onPointerEnd);
      comparison.addEventListener('pointercancel', onPointerEnd);
      comparison.addEventListener('lostpointercapture', onPointerEnd);

      if (range) {
        range.addEventListener('input', () => setPosition(Number(range.value || 50)));
        range.addEventListener('change', () => setPosition(Number(range.value || 50)));
        setPosition(Number(range.value || 50));
      } else {
        setPosition(50);
      }
    });
  }

  function initRichAccordions(section) {
    section.querySelectorAll('[data-bvm-rich-accordion]').forEach((block) => {
      if (block.dataset.bvmReady === 'true') return;
      block.dataset.bvmReady = 'true';

      const accordions = Array.from(block.querySelectorAll('[data-bvm-rich-accordion-item]'));
      if (!accordions.length) return;

      const shouldOpenFirstOnDesktop = block.dataset.firstOpenDesktop === 'true';
      const desktopQuery = window.matchMedia('(min-width: 750px)');

      function preserveAnchorPosition(anchor, topBefore) {
        window.requestAnimationFrame(() => {
          const topAfter = anchor.getBoundingClientRect().top;
          const delta = topAfter - topBefore;

          if (Math.abs(delta) > 1) {
            window.scrollBy({
              top: delta,
              left: 0,
              behavior: 'auto'
            });
          }
        });
      }

      function closeAllExcept(currentAccordion) {
        accordions.forEach((accordion) => {
          if (accordion !== currentAccordion) {
            accordion.open = false;
          }
        });
      }

      function setInitialState() {
        accordions.forEach((accordion) => {
          accordion.open = false;
        });

        if (shouldOpenFirstOnDesktop && desktopQuery.matches && accordions[0]) {
          accordions[0].open = true;
        }
      }

      setInitialState();

      accordions.forEach((accordion) => {
        const summary = accordion.querySelector('summary');

        if (summary) {
          summary.addEventListener('click', (event) => {
            const clickedLink = event.target.closest('a');
            const clickedInteractive = event.target.closest("button, input, select, textarea, label");

            if (clickedLink || clickedInteractive) return;

            event.preventDefault();
            event.stopPropagation();

            const wasOpen = accordion.open;
            const topBefore = summary.getBoundingClientRect().top;

            if (wasOpen) {
              accordion.open = false;
            } else {
              closeAllExcept(accordion);
              accordion.open = true;
            }

            preserveAnchorPosition(summary, topBefore);
          });
        }

        accordion.addEventListener('click', (event) => {
          if (summary && summary.contains(event.target)) return;

          const clickedLink = event.target.closest('a');
          const clickedInteractive = event.target.closest("button, input, select, textarea, label");

          if (clickedLink || clickedInteractive) return;
          if (!accordion.open) return;

          const anchor = summary || accordion;
          const topBefore = anchor.getBoundingClientRect().top;

          accordion.open = false;
          preserveAnchorPosition(anchor, topBefore);
        });
      });

      const onViewportChange = () => setInitialState();

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', onViewportChange);
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(onViewportChange);
      }
    });
  }

  function initFaqAccordions(section) {
    section.querySelectorAll('[data-bvm-faq-accordion]').forEach((block) => {
      if (block.dataset.bvmReady === 'true') return;
      block.dataset.bvmReady = 'true';

      const accordions = Array.from(block.querySelectorAll('[data-bvm-faq-accordion-item]'));
      if (!accordions.length) return;

      const shouldOpenFirstOnDesktop = block.dataset.firstOpenDesktop === 'true';
      const desktopQuery = window.matchMedia('(min-width: 750px)');
      let isSyncing = false;

      function closeAllExcept(currentAccordion) {
        isSyncing = true;

        accordions.forEach((accordion) => {
          if (accordion !== currentAccordion) {
            accordion.open = false;
          }
        });

        isSyncing = false;
      }

      function setInitialState() {
        accordions.forEach((accordion) => {
          accordion.open = false;
        });

        if (shouldOpenFirstOnDesktop && desktopQuery.matches && accordions[0]) {
          accordions[0].open = true;
        }
      }

      setInitialState();

      accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', () => {
          if (isSyncing || !accordion.open) return;
          closeAllExcept(accordion);
        });

        accordion.addEventListener('click', (event) => {
          const clickedLink = event.target.closest('a');
          const clickedInteractive = event.target.closest("button, input, select, textarea, label");
          const clickedSummary = event.target.closest('summary');

          if (clickedLink || clickedInteractive) return;
          if (clickedSummary) return;

          if (accordion.open) {
            accordion.open = false;
          }
        });
      });

      const onViewportChange = () => setInitialState();

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', onViewportChange);
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(onViewportChange);
      }
    });
  }

  function initReviews(section) {
    section.querySelectorAll('[data-bvm-reviews]').forEach((block) => {
      if (block.dataset.bvmReviewsReady === 'true') return;
      block.dataset.bvmReviewsReady = 'true';

      const rows = Array.from(block.querySelectorAll('[data-bvm-review-row]'));
      // Liquid orders reviews by visitor language, then photos. Preserve that order
      // for the initial display, rating filters and expanded list.
      const filterButtons = Array.from(block.querySelectorAll('[data-bvm-review-filter]'));
      const filterStatus = block.querySelector('[data-bvm-review-filter-status]');
      const loadMoreButton = block.querySelector('[data-bvm-review-load-more]');
      const loadMoreLabel = block.querySelector('[data-bvm-review-load-more-label]');
      const initialVisibleReviews = 8;

      let activeReviewFilter = "all";
      let reviewsExpanded = false;

      function updateReviewList() {
        let matchingCount = 0;
        let visibleCount = 0;

        rows.forEach((row) => {
          const matchesFilter =
            activeReviewFilter === "all" ||
            row.dataset.bvmReviewRating === activeReviewFilter;

          let shouldShow = matchesFilter;

          if (
            matchesFilter &&
            activeReviewFilter === "all" &&
            reviewsExpanded === false &&
            matchingCount >= initialVisibleReviews
          ) {
            shouldShow = false;
          }

          row.hidden = !shouldShow;

          if (matchesFilter) {
            matchingCount += 1;
          }

          if (shouldShow) {
            visibleCount += 1;
          }
        });

        filterButtons.forEach((button) => {
          const isActive = button.dataset.bvmReviewFilter === activeReviewFilter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (filterStatus) {
          if (activeReviewFilter === "all") {
            if (matchingCount > initialVisibleReviews && reviewsExpanded === false) {
              filterStatus.textContent = (/^fr(?:-|$)/i.test(document.documentElement.lang) ? `Affichage de ${visibleCount} avis sur ${matchingCount}` : `Showing ${visibleCount} of ${matchingCount} reviews`);
            } else {
              filterStatus.textContent = (/^fr(?:-|$)/i.test(document.documentElement.lang) ? `${matchingCount} avis au total` : `All ${matchingCount} ${matchingCount === 1 ? 'review' : 'reviews'}`);
            }
          } else {
            filterStatus.textContent = (/^fr(?:-|$)/i.test(document.documentElement.lang) ? `${matchingCount} avis à ${activeReviewFilter} étoile${activeReviewFilter === '1' ? '' : 's'}` : `${matchingCount} ${matchingCount === 1 ? 'review' : 'reviews'} rated ${activeReviewFilter} star${activeReviewFilter === '1' ? '' : 's'}`);
          }
        }

        if (loadMoreButton) {
          const shouldDisplayLoadMore =
            activeReviewFilter === "all" &&
            rows.length > initialVisibleReviews;

          loadMoreButton.hidden = !shouldDisplayLoadMore;
          loadMoreButton.dataset.expanded = reviewsExpanded ? 'true' : 'false';
          loadMoreButton.setAttribute('aria-expanded', reviewsExpanded ? 'true' : 'false');

          if (loadMoreLabel) {
            loadMoreLabel.textContent = reviewsExpanded
              ? window.BV_T("bonvent_studio.reviews_ui.show_fewer_reviews_e5c9e05487","Show fewer reviews")
              : (/^fr(?:-|$)/i.test(document.documentElement.lang) ? `Voir les ${rows.length} avis` : `View all ${rows.length} reviews`);
          }
        }
      }

      function setReviewFilter(filterValue) {
        activeReviewFilter = filterValue || "all";

        if (activeReviewFilter === "all") {
          reviewsExpanded = false;
        }

        updateReviewList();
      }

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          setReviewFilter(button.dataset.bvmReviewFilter || "all");
        });
      });

      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', () => {
          reviewsExpanded = !reviewsExpanded;
          updateReviewList();

          if (reviewsExpanded === false) {
            block.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      }

      updateReviewList();

      const lightbox = block.querySelector('[data-bvm-review-lightbox]');
      const lightboxImage = block.querySelector('[data-bvm-review-lightbox-image]');
      const lightboxClose = lightbox ? lightbox.querySelector('.bvm-product-reviews-zero__lightbox-close') : null;

      function openReviewImage(trigger) {
        if (!lightbox || !lightboxImage || !trigger) return;

        const fullSrc = trigger.dataset.bvmReviewImageFull || '';
        if (!fullSrc) return;

        lightboxImage.src = fullSrc;
        lightboxImage.alt = trigger.dataset.bvmReviewImageAlt || window.BV_T("bonvent_studio.reviews_ui.customer_review_photo_1774574291","Customer review photo");
        lightbox.hidden = false;
        document.documentElement.classList.add('bvm-review-lightbox-open');

        if (lightboxClose) {
          lightboxClose.focus();
        }
      }

      function closeReviewImage() {
        if (!lightbox || lightbox.hidden) return;

        lightbox.hidden = true;
        document.documentElement.classList.remove('bvm-review-lightbox-open');

        if (lightboxImage) {
          lightboxImage.src = '';
          lightboxImage.alt = '';
        }
      }

      block.addEventListener('click', (event) => {
        const imageTrigger = event.target.closest('[data-bvm-review-image-open]');

        if (imageTrigger && block.contains(imageTrigger)) {
          event.preventDefault();
          openReviewImage(imageTrigger);
          return;
        }

        const closeTrigger = event.target.closest('[data-bvm-review-image-close]');

        if (closeTrigger && lightbox && lightbox.contains(closeTrigger)) {
          event.preventDefault();
          closeReviewImage();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === "Escape" && lightbox && !lightbox.hidden) {
          closeReviewImage();
        }
      });
    });
  }

  function initRelatedSliders(section) {
    section.querySelectorAll('.bvm-related-products-zero').forEach((block) => {
      if (block.dataset.bvmSliderReady === 'true') return;
      block.dataset.bvmSliderReady = 'true';

      const track = block.querySelector('[data-bvm-related-track]');
      const prev = block.querySelector('[data-bvm-related-prev]');
      const next = block.querySelector('[data-bvm-related-next]');

      if (!track || !prev || !next) return;

      prev.addEventListener('click', () => scrollByCard(track, -1));
      next.addEventListener('click', () => scrollByCard(track, 1));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initBvmProductZero());
  } else {
    initBvmProductZero();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBvmProductZero(event.target);
  });
})();